import { WarningAmber } from '@mui/icons-material';
import { useOidcWithAdmin } from '@revenuewell/front-end-bundle';
import { useEffect, useState } from 'react';
import CareCreditIcon from '../../../../../assets/carecredit_logo.svg';
import { useFeatureFlags } from '../../../../../hooks/feature-flags/use-feature-flags';
import { usePatientProfile } from '../../../../../hooks/use-patient-profile';
import { WidgetRoutePath } from './route-config';

export const useMainMenuConfig = () => {
  const { contactDetails, patientInfo, careCreditInfo, showFormsForPatient } = usePatientProfile();
  const { hasFeature } = useFeatureFlags();
  const [locationId, setLocationId] = useState<number | null>(null);

  const { getClaims } = useOidcWithAdmin();

  useEffect(() => {
    (async () => {
      const claims = await getClaims();
      setLocationId(claims.locationId);
    })();
  }, [getClaims]);

  const contactLocationId = contactDetails?.location?.id;

  const shouldShowReputation =
    contactLocationId &&
    hasFeature(contactLocationId, 'Reputation') &&
    locationId &&
    hasFeature(locationId, 'Reputation');

  const menuConfig = [
    { title: 'General', path: WidgetRoutePath.GENERAL, icon: null },
    { title: 'Patient Connect 365', path: WidgetRoutePath.PATIENT_CONNECT_365, icon: null },
    {
      title: 'Alerts & Tasks',
      path: WidgetRoutePath.ALERTS_TASKS,
      icon:
        patientInfo?.patientAlerts && patientInfo?.patientAlerts.length > 0 ? (
          <WarningAmber sx={{ color: 'rgba(249, 190, 40, 1)', display: 'flex' }} />
        ) : null
    },
    { title: 'Inbox', path: WidgetRoutePath.INBOX, icon: null },
    ...(showFormsForPatient ? [{ title: 'Forms', path: WidgetRoutePath.FORMS, icon: null }] : []),
    { title: 'Visits', path: WidgetRoutePath.VISITS, icon: null },
    { title: 'Scheduled Comms', path: WidgetRoutePath.SCHEDULED_COMMS, icon: null },
    { title: 'Communication Preferences', path: WidgetRoutePath.COMM_PREFERENCES, icon: null },
    { title: 'Treatment Plans', path: WidgetRoutePath.TREATMENT_PLANS, icon: null },
    {
      title: 'Billing',
      path: WidgetRoutePath.BILLING,
      icon:
        careCreditInfo && careCreditInfo.preStatus && careCreditInfo.preApprovedAmount ? (
          <img src={CareCreditIcon} alt="" style={{ width: '18px' }} />
        ) : null
    },
    ...(shouldShowReputation
      ? [{ title: 'Patient Feedback', path: WidgetRoutePath.PATIENT_FEEDBACK, icon: null }]
      : []),
    { title: 'Patient Files', path: WidgetRoutePath.FILES, icon: null },
    { title: 'Notes', path: WidgetRoutePath.NOTES, icon: null }
  ];

  return menuConfig;
};
